var _react_refresh_temp_1;
import { jsx as _jsx } from "react/jsx-runtime";
import { Icon } from '../Icon';
import CreditCardSVG from './credit-card-02.icon.svg';
export const CreditCardIcon = (iconInstanceProps) => {
    return _jsx(Icon, { ...iconInstanceProps, SvgComponent: CreditCardSVG });
};
_react_refresh_temp_1 = CreditCardIcon;
$RefreshReg$(_react_refresh_temp_1, "CreditCardIcon");
